import http from "../http-common";

class batchReportService {
  getAll() {
    return http.get("/batchreport");
  }

  get(id) {
    return http.get(`/batchreport/${id}`);
  }

  getByProject(id) {
    return http.get(`/batchreport/getByProject/${id}`);
  }

  getBatchByDates(startDate, endDate) {
    return http.get(`/batchreport/batchByDates/${startDate}/${endDate}`);
  }

  fetchByDates(data) {
    return http.post("/batchreport/byDates", data);
  }

  create(data) {
    return http.post("/batchreport", data);
  }

  update(id, data) {
    return http.put(`/batchreport/${id}`, data);
  }

  delete(id) {
    return http.delete(`/batchreport/${id}`);
  }

  deleteAll() {
    return http.delete(`/batchreport`);
  }
}

export default new batchReportService();
